'use client'

import SectionHeading from "@/components/SectionHeading"
import { cn } from "@/lib/utils"
import { urlForImage } from "@/sanity/lib/image"
import { createDataAttribute } from "next-sanity"
import Image from "next/image"

interface ClientListLogosProps {
	heading: string
	logos: any
	documentId: string
	_key: string
}

export default function ClientListLogos({heading, logos, documentId, _key}:ClientListLogosProps) {
	return (
		<div className="section px-site"
			key={_key}
			data-sanity={createDataAttribute({
				id: documentId,
				type: 'project',
				path: `contentBlocks[_key=="${_key}"]`,
			}).toString()}>
			<div className="mb-section--sm sm:text-center">
				<SectionHeading heading={heading || "Clients"} />
			</div>
			<div className="grid grid-cols-2 md:grid-cols-5 gap-x-4 sm:gap-x-8 gap-y-8 sm:gap-y-12">
				{logos?.map((logo, index) => {
					const w = logo?.asset?.metadata?.dimensions?.width
					const h = logo?.asset?.metadata?.dimensions?.height
					const aspectRatio = w / h

					let widthClass = 'w-2/3'

					if (aspectRatio < 1.1) {
						widthClass = 'w-1/3'
					}

					if (aspectRatio > 0.9 && aspectRatio < 1.1) {
						widthClass = 'w-2/5'
					}

					return(
						<div key={logo?.asset?.url} className="col-span-1 grid place-items-center px-4 sm:px-16 md:px-0">
							<Image
								className={cn(`h-auto contrast-200 mix-blend-multiply dark:mix-blend-screen dark:invert`, widthClass)}
								src={urlForImage(logo).width(720).url()}
								sizes='@min-width: (1024px) 20vw, @min-width: (768px) 50vw'
								width={logo?.asset?.metadata?.dimensions?.width}
								height={logo?.asset?.metadata?.dimensions?.height}
								alt={logo?.name || ""}
								placeholder="blur"
								blurDataURL={logo?.asset?.metadata?.lqip}
								quality={90}
							/>
						</div>
					)}
				)}
			</div>
		</div>
	)
}